var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "app-footer no-print" }, [
      _c("div", { staticClass: "footer-wrap" }),
      _vm._v(" "),
      _c("img", {
        staticStyle: { display: "none" },
        attrs: {
          height: "1",
          width: "1",
          alt: "",
          src: "https://px.ads.linkedin.com/collect/?pid=2807145&fmt=gif",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }